module.exports = __webpack_public_path__ + "images/1856269c48af88cd1c8d3e3040ed26bc.svg";